<cancel-confirm-modal-tag>
   <style>
    .modal__content_inner {
      max-height: 80vh;
      overflow-y: auto;
    }
    .wp60 {
      width: 60%;
    }
  </style>

  <div
    class="modal js-modal"
    is="modal-base"
    is-open="{ props.isOpen }"
  >
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <h3 class="modal_heading margin-spacing-3_bottom">
          辞退する
        </h3>

        <p class="modal_lead">
          辞退をするとこのプロジェクトを受託することができなくなります。
        </p>
        <div class="wrap_button margin-spacing-2_top">
          <div
            class="button button-secondary-large button-border margin-spacing-1_right"
            type="button"
            value="キャンセル"
            onclick="{ props.onClose }"
          >
            キャンセル
          </div>
          <div
            class="button button-secondary-large button-notice margin-spacing-1_right"
            type="button"
            value="辞退する"
            onclick="{ props.onSubmit }"
          >
            辞退する
          </div>
        </div>
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>

  <script>
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      }
    };
  </script>

</cancel-confirm-modal-tag>
